export enum AppRoutes {
  BASE_ROUTE = "/",
  SUBSCRIPTIONS = "/subscriptions",
  OPTIONS = "/options",
  SUCCESS = "/success",
  FAIL = "/fail",
  CANCEL = "/cancel",
  UNKNOWN = "/unknown",
  PENDING = "/pending",
  MANAGE_PAYMENTS = "/manage-payments",
  MANAGE_SUBSCRIPTIONS = "/manage-subscriptions",
  MANAGE_SUBSCRIPTIONS_EDIT = "/manage-subscriptions/edit",
  MANAGE_SUBSCRIPTIONS_CANCEL_CONFIRM = "/manage-subscriptions/cancel/confirm",
  MANAGE_SUBSCRIPTIONS_CANCEL_REASON = "/manage-subscriptions/cancel/reason",
  MANAGE_SUBSCRIPTIONS_EDIT_RESULT = "/manage-subscriptions/edit/result",
  MANAGE_SUBSCRIPTIONS_RETENTION_OFFERS = "/manage-subscriptions/cancel/retention-offers",
  TRACKER_TRANSFER_OFFER = '/tracker-transfer-offer',
}
